import { Controller } from "@hotwired/stimulus"
import flatpickr from 'flatpickr'
import { French } from 'flatpickr/dist/l10n/fr'

export default class extends Controller {
    static values = {
        options: Object
    }

    connect() {
        const options = Object.assign({ locale: French, dateFormat: "d-m-Y"}, this.optionsValue);

        flatpickr(this.element, options)
    }
}